import React, { useEffect, useState } from "react";

import {
    Grid,
    ToggleButton,
    ToggleButtonGroup,
    Tooltip,
    Typography,
} from "@mui/material";

import {
    DATATYPE_CHECKIN,
    DATATYPE_CHECKIN_NAME,
    DATATYPE_CHECKOUT,
    DATATYPE_CHECKOUT_NAME,
    DATATYPE_RESDATE,
    DATATYPE_RESDATE_NAME,
} from "../helpers/filters";

const ToggleButtonTitled = ({
    TITLE = "Show performance by",
    values = {
        DATATYPE_RESDATE: DATATYPE_RESDATE_NAME,
        DATATYPE_CHECKIN: DATATYPE_CHECKIN_NAME,
        DATATYPE_CHECKOUT: DATATYPE_CHECKOUT_NAME,
    },
    valueSet = DATATYPE_RESDATE,
    onChange = () => {},
    ITEM_HEIGHT = "50px",
    size = "large",
    TITLE_TOOLTIP = null,
    TITLE_TOOLTIP_PLACEMENT = "top",
}) => {
    return (
        <Grid item>
            {TITLE && (
                <>
                    {TITLE_TOOLTIP ? (
                        <Tooltip
                            title={TITLE_TOOLTIP}
                            placement={TITLE_TOOLTIP_PLACEMENT}
                            arrow
                        >
                            <Typography>{TITLE}</Typography>
                        </Tooltip>
                    ) : (
                        <Typography>{TITLE}</Typography>
                    )}
                </>
            )}
            <ToggleButtonGroup
                size={size}
                value={valueSet}
                exclusive
                onChange={(e, v) => {
                    if (v) {
                        onChange(e, v);
                    }
                }}
                sx={{
                    height: ITEM_HEIGHT,
                    border: 1,
                    borderColor: "divider",
                    "& .MuiToggleButtonGroup-grouped": {
                        margin: "4px",
                        border: "none",
                        transition: "background-color 300ms",
                        borderRadius: "4px",
                        "&:not(:first-of-type)": {
                            borderRadius: "4px",
                        },
                        "&:not(:last-of-type)": {
                            borderRadius: "4px",
                        },
                        pt: 0,
                        pb: 0,
                        pr: 2,
                        pl: 2,
                        textTransform: "none",
                        whiteSpace: "nowrap",
                    },

                    "& .MuiToggleButton-root": {
                        color: "primary.contrastText",
                    },

                    "&& .MuiToggleButton-root.Mui-selected": {
                        color: "primary.contrastText",
                        backgroundColor: "primary.main",
                    },

                    "&& .MuiToggleButton-root.Mui-selected:hover": {
                        color: "primary.contrastText",
                        backgroundColor: "primary.dark",
                    },
                }}
            >
                {Object.entries(values).map(([val, labelOrObj]) => {
                    const label =
                        typeof labelOrObj === "object"
                            ? labelOrObj.label
                            : labelOrObj;
                    const icon =
                        typeof labelOrObj === "object" ? labelOrObj.icon : null;
                    return (
                        <ToggleButton
                            value={val}
                            key={val}
                            sx={icon ? { gap: 1 } : undefined}
                        >
                            {icon}
                            {label}
                        </ToggleButton>
                    );
                })}
            </ToggleButtonGroup>
        </Grid>
    );
};

export default ToggleButtonTitled;
